/*
 * RearDrive Society — interaction layer
 * Lightweight, dependency-free scroll reveals + subtle parallax.
 * Respects prefers-reduced-motion and only initializes once.
 */
(() => {
  if (window.__rdsInitialized) return;
  window.__rdsInitialized = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----- Scroll reveals ----- */
  const revealEls = () => Array.from(document.querySelectorAll('[data-rds-reveal]'));

  const showAll = () => revealEls().forEach((el) => el.classList.add('rds-in'));

  if (reduceMotion || !('IntersectionObserver' in window)) {
    showAll();
  } else {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          const delay = el.getAttribute('data-rds-delay');
          if (delay) el.style.setProperty('--rds-delay', `${delay}ms`);
          el.classList.add('rds-in');
          io.unobserve(el);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    const observeAll = () => revealEls().forEach((el) => io.observe(el));
    observeAll();

    // Re-scan when the theme editor injects/updates sections.
    document.addEventListener('shopify:section:load', observeAll);
  }

  /* ----- Subtle parallax ----- */
  if (!reduceMotion) {
    const parallaxEls = Array.from(document.querySelectorAll('[data-rds-parallax]'));
    if (parallaxEls.length) {
      let ticking = false;

      const update = () => {
        const vh = window.innerHeight || 1;
        parallaxEls.forEach((el) => {
          const rect = el.getBoundingClientRect();
          if (rect.bottom < -200 || rect.top > vh + 200) return;
          const speed = parseFloat(el.getAttribute('data-rds-parallax')) || 0.12;
          const progress = (rect.top + rect.height / 2 - vh / 2) / vh;
          const shift = -(progress * speed * 100);
          el.style.setProperty('--rds-parallax-y', `${shift.toFixed(2)}px`);
        });
        ticking = false;
      };

      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }
  }
})();
